/* Rebranding hale & hound (22/10/2026) : le bloc d'offre Moon Bundle écrit ses couleurs en style en ligne
   (« !important »), qu'aucune feuille de style ne peut battre. Ce script remplace, dans ces styles en ligne, chaque
   couleur de l'ancienne charte par celle de la nouvelle. Il ne touche qu'aux éléments Moon Bundle, de ce thème.

   Garde-fous (leçon du 17/10, boucle infinie sous MutationObserver) :
   - idempotent : il n'écrit que si le texte du style change ; après sa passe, plus rien à remplacer ;
   - étranglé : une passe toutes les 30 ms au plus ;
   - plafonné : 20 corrections au plus par élément, au cas où l'app réécrirait sans fin. */
(function () {
  var MAP = [
    [/#1F4A3D/gi, '#200304'], [/#182420/gi, '#200304'], [/#E9A83C/gi, '#E4583A'], [/#D96C47/gi, '#E4583A'],
    [/#F5EFE3/gi, '#FAF3EF'], [/#E2D9C8/gi, '#EAD9CF'], [/#FFF7EC/gi, '#FFFFFF'], [/#6B6152/gi, '#6B5F5C'],
    [/#9A9184/gi, '#9A8F8B'],
    [/rgb\(\s*251,\s*247,\s*239\s*\)/gi, 'rgb(250, 243, 239)'], [/rgb\(\s*234,\s*223,\s*201\s*\)/gi, 'rgb(241, 225, 216)'],
    [/rgb\(\s*31,\s*74,\s*61\s*\)/gi, 'rgb(32, 3, 4)'], [/rgb\(\s*24,\s*36,\s*32\s*\)/gi, 'rgb(32, 3, 4)'],
    [/rgb\(\s*245,\s*239,\s*227\s*\)/gi, 'rgb(255, 255, 255)'], [/rgb\(\s*233,\s*168,\s*60\s*\)/gi, 'rgb(228, 88, 58)'],
    [/rgb\(\s*24,\s*59,\s*48\s*\)/gi, 'rgb(228, 88, 58)'], [/rgb\(\s*242,\s*201,\s*141\s*\)/gi, 'rgb(255, 255, 255)'],
    [/rgb\(\s*249,\s*240,\s*223\s*\)/gi, 'rgb(255, 255, 255)'], [/rgb\(\s*147,\s*97,\s*48\s*\)/gi, 'rgb(228, 88, 58)'],
    [/rgb\(\s*255,\s*240,\s*220\s*\)/gi, 'rgb(255, 255, 255)'], [/rgb\(\s*215,\s*154,\s*102\s*\)/gi, 'rgb(228, 88, 58)'],
    [/rgb\(\s*113,\s*51,\s*19\s*\)/gi, 'rgb(228, 88, 58)'], [/rgb\(\s*255,\s*247,\s*236\s*\)/gi, 'rgb(255, 255, 255)'],
    [/rgb\(\s*226,\s*217,\s*200\s*\)/gi, 'rgb(234, 217, 207)'], [/rgb\(\s*255,\s*248,\s*239\s*\)/gi, 'rgb(250, 243, 239)'],
    [/rgb\(\s*193,\s*150,\s*96\s*\)/gi, 'rgb(241, 225, 216)']
  ];
  var compte = new WeakMap();
  var suivis = new WeakSet();
  var prevu = false;

  function corriger(el) {
    var s = el.getAttribute('style');
    if (!s) return;
    var t = s;
    for (var i = 0; i < MAP.length; i++) t = t.replace(MAP[i][0], MAP[i][1]);
    if (t === s) return;
    var n = (compte.get(el) || 0) + 1;
    if (n > 20) return;
    compte.set(el, n);
    el.setAttribute('style', t);
  }

  var obsRacine = new MutationObserver(planifier);

  function corrigerStyle(st) {  // la feuille de style du bundle (couleurs réglées dans l'app)
    var s = st.textContent, t = s;
    for (var i = 0; i < MAP.length; i++) t = t.replace(MAP[i][0], MAP[i][1]);
    if (t === s) return;
    var n = (compte.get(st) || 0) + 1;
    if (n > 20) return;
    compte.set(st, n);
    st.textContent = t;
  }

  /* Bundle A « le reçu » (27/10/2026) : la maquette maquettes/bundles-3-propositions.html (A), validée par Kennan
     (« vzy publie le »). Seulement sur le bundle du harnais. Les deux packs en tuiles côte à côte, la taille et la couleur
     de chaque harnais, la case « Match the leash », puis « Your box » : ce que contient le panier, ligne par ligne, et
     l'économie. On ne réécrit aucun nœud de l'app (Svelte) : les textes vont dans des attributs data-hh-*, affichés par
     la feuille hh-rebrand.css (::before/::after) ; la seule pièce ajoutée est le reçu, sous les tuiles. Chaque écriture
     compare d'abord. La logique de l'offre reste celle du code personnalisé de l'app : la laisse assortie prend la couleur
     de chaque harnais, et cocher la case retire la bungee offerte du panier ; le reçu ne fait que lire cet état. */
  var BUNDLE_HARNAIS = 'a7dd4599-6434-485b-837d-dccd3b984a96';
  var LAISSE_OFFERTE = '09c829bb-73d1-4c24-a981-a415d5f08814';
  var LAISSE_ASSORTIE = 'fb4ce05a-d3da-4725-9f60-a1a2e276cfad';
  var CDN = 'https://cdn.shopify.com/s/files/1/0971/1445/6448/files/';
  var TICKET = CDN + 'ticket-100-refund-chance-30.png?v=1793601744&width=96';
  var IMG = {  // les mêmes vignettes que le code personnalisé de l'app
    harnais: { 'Black': '12_1f57fd52-13de-4ea6-8ff9-712fdf356276_200x.webp?v=1783543265', 'Grey': '14_200x.webp?v=1783543159',
      'Beige': '17_200x.webp?v=1783543159', 'Khaki': 'Army_Green_Harness_200x.webp?v=1783543159', 'Orange': '13_200x.webp?v=1783543159',
      'Red': '15_200x.webp?v=1783543159', 'Turquoise': '18_200x.webp?v=1783543159', 'Sky Blue': '19_200x.webp?v=1783543159',
      'Pink': '16_200x.webp?v=1783543159' },
    laisse: { 'Black': 'Leash_200x.webp?v=1783543727', 'Grey': '11_7f8384d2-dc0c-4455-8295-8d7804c8c342_200x.webp?v=1783543727',
      'Beige': '13_f864e83f-868a-42e1-9a4b-a07d587e9df3_200x.webp?v=1783543727', 'Khaki': 'WhatsApp_Image_2026-05-26_at_02.27.18_200x.webp?v=1783543794',
      'Orange': '10_8f7d7518-9525-470c-aea7-065b581bc0c4_200x.webp?v=1783543727', 'Red': '12_64b3ad97-7ddb-41ab-b761-2e58dae6b540_200x.webp?v=1783543727',
      'Turquoise': '14_e08ded87-721c-4ab1-9371-d9bf8113571b_200x.webp?v=1783543727', 'Sky Blue': '15_ab7b891d-6dc5-4d1a-8697-686e6cd18fe2_200x.webp?v=1783543727',
      'Pink': '16_147110d0-8be2-4bd5-bf39-0dfbde85168d_200x.webp?v=1783543727' }
  };
  function image(type, couleur) { return CDN + (IMG[type][couleur] || IMG[type].Black); }
  function echap(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function argent(n) { return '$' + n.toFixed(2); }
  function choisi(row, nom) {
    var b = row.querySelector('.moonbundle-swatch-buttons[data-name="' + nom + '"] [aria-checked="true"]');
    return b ? (b.getAttribute('data-value') || '').trim() : '';
  }
  function attr(el, nom, v) { if (el && el.getAttribute(nom) !== v) el.setAttribute(nom, v); }
  function remplacer(el, t) {
    if (!el) return;
    attr(el, 'data-hh-t', t);
    if (!el.classList.contains('hh-mb-t')) el.classList.add('hh-mb-t');
  }
  function lirePrix(el) {
    var m = el ? el.textContent.replace(/,/g, '').match(/\d+(\.\d+)?/) : null;
    return m ? parseFloat(m[0]) : 0;
  }
  function sansCentimes(t) { return (t || '').trim().replace(/\.00$/, ''); }
  function panneau(r) {  // le code personnalisé de Moon Bundle US pose un panneau rosé en ligne (!important), une seule fois
    if (r.dataset.hhPanel !== '1' || r.dataset.hhBlanc === '1') return;
    r.dataset.hhBlanc = '1';
    var P = { 'background-color': 'transparent', 'border': '0px', 'border-radius': '0px', 'padding': '0px', 'box-shadow': 'none', 'margin-bottom': '0px' };
    for (var k in P) r.style.setProperty(k, P[k], 'important');
  }
  function textes(r) {
    if (r.getAttribute('data-bundle-id') !== BUNDLE_HARNAIS) return;
    panneau(r);
    var titre = r.querySelector('.moonbundle-title');
    remplacer(titre, 'Choose your pack');
    var o1 = r.querySelector('.moonbundle-option');
    var p1 = lirePrix(o1 && o1.querySelector('.moonbundle-option-single-price')), a1 = lirePrix(o1 && o1.querySelector('.moonbundle-option-old-price'));
    var remise = a1 > p1 && p1 ? Math.round((a1 - p1) / a1 * 100) + '% off' : '';
    attr(titre, 'data-hh-remise', remise && document.getElementById('hh-fall-offer') ? 'Early Black Friday · ' + remise : remise);

    r.querySelectorAll('.moonbundle-option').forEach(function (o) {
      var q = o.querySelector('.moonbundle-option-quantity');
      var nb = q ? parseInt(q.textContent.replace(/\D/g, ''), 10) || 1 : 1;
      var prix = lirePrix(o.querySelector('.moonbundle-option-single-price'));
      var avant = lirePrix(o.querySelector('.moonbundle-option-old-price'));

      var sous = o.querySelector('.moonbundle-option-subtitle');
      if (sous && nb > 1 && prix) remplacer(sous, '$' + (prix / nb).toFixed(2) + ' each');
      var bandeau = o.parentElement && o.parentElement.querySelector('.moonbundle-best-seller-sticker');
      if (bandeau) {
        remplacer(bandeau, 'Best value');
        attr(bandeau, 'data-hh-save', avant > prix ? 'Save $' + Math.round(avant - prix) : '');
      }

      var offerte = o.querySelector('.moonbundle-upsell-item[data-upsell-id="' + LAISSE_OFFERTE + '"]');
      if (offerte) {
        remplacer(offerte.querySelector('.moonbundle-upsell-title-text'), nb > 1 ? nb + ' bungee leashes' : 'Bungee leash');
        var ancien = offerte.querySelector('.moonbundle-upsell-original-price');
        if (ancien) remplacer(ancien, sansCentimes(ancien.textContent));
      }

      o.querySelectorAll('.moonbundle-variant-select > div:first-child').forEach(function (e) {
        var m = e.textContent.trim().match(/^#(\d+)$/);
        if (m) { remplacer(e, 'Harness ' + m[1]); e.classList.add('hh-mb-num'); }
        var row = e.closest('.moonbundle-variant-row');
        var url = 'url("' + image('harnais', row ? choisi(row, 'Color') : '') + '")';
        if (e.classList.contains('hh-mb-num') && e.style.getPropertyValue('--hh-img') !== url) e.style.setProperty('--hh-img', url);
      });
      // la case de la laisse assortie : son titre et sa phrase (posée par l'app : « Same lead, in Orange »…)
      var assortie = o.querySelector('.moonbundle-upsell-item[data-upsell-id="' + LAISSE_ASSORTIE + '"]');
      if (assortie) {
        remplacer(assortie.querySelector('.moonbundle-upsell-title-text'), nb > 1 ? 'Match the leashes' : 'Match the leash');
        var sub = assortie.querySelector('[data-hh-sub]'), t = sub ? sub.textContent.trim() : '', x;
        var phrase = (x = t.match(/^Same lead, in (.+)$/)) ? x[1] + ' leash instead of the free black bungee'
          : (x = t.match(/^Two leads, both in (.+)$/)) ? 'Two ' + x[1] + ' leashes instead of the free black bungees'
          : (x = t.match(/^One in (.+), one in (.+)$/)) ? 'One ' + x[1] + ', one ' + x[2] + ', instead of the free black bungees' : '';
        if (sub && phrase) remplacer(sub, phrase);
        assortie.querySelectorAll('.moonbundle-upsell-original-price, .hh-p-old').forEach(function (e) {
          if (/\.00\s*$/.test(e.textContent)) remplacer(e, sansCentimes(e.textContent));
        });
      }
      o.querySelectorAll('.moonbundle-option-selector').forEach(function (sel) {
        var lab = sel.querySelector('.moonbundle-option-name');
        var g = sel.querySelector('[role="radiogroup"]');
        if (!lab || !g) return;
        var actif = g.querySelector('[aria-checked="true"]');
        attr(lab, 'data-hh-lab', lab.textContent.trim());
        attr(lab, 'data-hh-val', actif ? '· ' + (actif.getAttribute('aria-label') || actif.getAttribute('data-value') || '') : '');
        if (!lab.classList.contains('hh-mb-lab')) lab.classList.add('hh-mb-lab');
      });
    });

    recu(r);
  }

  /* « Your box » : le contenu réel du panier pour le pack choisi, lu dans l'app à chaque passe. */
  function ligne(ico, nom, detail, droite, cls) {
    return '<div class="hh-recu__l' + (cls ? ' ' + cls : '') + '">' + ico + '<span class="hh-recu__nom">' + echap(nom) +
      (detail ? '<small>' + echap(detail) + '</small>' : '') + '</span><span class="hh-recu__px">' + droite + '</span></div>';
  }
  function vignette(url) { return '<img class="hh-recu__ico" src="' + echap(url) + '" alt="" width="28" height="28" loading="lazy">'; }
  function recu(r) {
    var o = r.querySelector('.moonbundle-option.moonbundle-option-active');
    var grille = r.querySelector('.moonbundle-options-horizontal');
    if (!o || !grille) return;
    var choix = [].map.call(o.querySelectorAll('.moonbundle-variant-row'), function (row) {
      return { taille: choisi(row, 'Size'), couleur: choisi(row, 'Color') || 'Black' };
    });
    if (!choix.length) choix = [{ taille: '', couleur: 'Black' }];
    var n = choix.length;
    var prix = lirePrix(o.querySelector('.moonbundle-option-single-price')), avant = lirePrix(o.querySelector('.moonbundle-option-old-price'));
    var offerte = o.querySelector('.moonbundle-upsell-item[data-upsell-id="' + LAISSE_OFFERTE + '"]');
    var assortie = o.querySelector('.moonbundle-upsell-item[data-upsell-id="' + LAISSE_ASSORTIE + '"]');
    var cbO = offerte && offerte.querySelector('input[type="checkbox"]'), cbA = assortie && assortie.querySelector('input[type="checkbox"]');
    var plan = r.querySelector('.moonbundle-gift-footer-text'), planPrix = r.querySelector('.moonbundle-gift-horizontal-block-right .moonbundle-price');

    var detail = choix.map(function (c) { return (c.taille ? c.taille + ' · ' : '') + c.couleur; }).join(', ');
    var valeur = avant || prix, paye = prix;
    var h = ligne(vignette(image('harnais', choix[0].couleur)), n > 1 ? n + ' no-pull harnesses' : 'No-pull harness', detail,
      (avant > prix ? '<s>' + sansCentimes(argent(avant)) + '</s>' : '') + '<b>' + argent(prix) + '</b>');
    if (cbO && cbO.checked) {
      var vo = lirePrix(offerte.querySelector('.moonbundle-upsell-original-price'));
      valeur += vo;
      h += ligne(vignette(image('laisse', 'Black')), n > 1 ? n + ' bungee leashes' : 'Bungee leash', 'Black',
        (vo ? '<s>' + sansCentimes(argent(vo)) + '</s>' : '') + '<span class="hh-recu__free">FREE</span>');
    }
    if (cbA && cbA.checked) {
      var pu = lirePrix(assortie.querySelector('.moonbundle-upsell-price')), au = lirePrix(assortie.querySelector('.moonbundle-upsell-original-price'));
      choix.forEach(function (c) {
        valeur += au || pu; paye += pu;
        h += ligne(vignette(image('laisse', c.couleur)), 'Matching leash', c.couleur,
          (au > pu ? '<s>' + sansCentimes(argent(au)) + '</s>' : '') + '<b>' + argent(pu) + '</b>');
      });
    }
    if (plan) {
      var vp = lirePrix(planPrix);
      valeur += vp;
      h += ligne('<span class="hh-recu__ico hh-recu__ico--plan" aria-hidden="true"></span>', plan.textContent.trim().replace(/^The /, ''), '',
        (vp ? '<s>' + sansCentimes(argent(vp)) + '</s>' : '') + '<span class="hh-recu__free">FREE</span>');
    }
    /* 02/11/2026 : le ticket Early Black Friday (1 commande sur 30 remboursée), ajouté au panier avec le pack */
    h += ligne(vignette(TICKET), '100% Refund Chance', 'Every 30th order is refunded', '<span class="hh-recu__free">FREE</span>');
    h += ligne('<span class="hh-recu__ico hh-recu__ico--garantie" aria-hidden="true"></span>', 'Lifetime guarantee', '',
      '<span class="hh-recu__inc">INCLUDED</span>', 'hh-recu__l--fin');
    if (valeur > paye) h += '<div class="hh-recu__eco">You save <b>' + argent(valeur - paye) + '</b> today</div>';

    var el = r.querySelector('.hh-recu');
    if (!el) {
      el = document.createElement('div');
      el.className = 'hh-recu';
      el.setAttribute('aria-label', 'Your box');
    }
    if (el.previousElementSibling !== grille) grille.parentNode.insertBefore(el, grille.nextSibling);
    if (el.innerHTML !== h) el.innerHTML = h;
  }

  function passe() {
    var feuilles = document.querySelectorAll('style[id^="moonbundle-custom-css"]');
    for (var k = 0; k < feuilles.length; k++) corrigerStyle(feuilles[k]);
    var racines = document.querySelectorAll('.moonbundle-box');
    for (var i = 0; i < racines.length; i++) {
      var r = racines[i];
      corriger(r);
      var enfants = r.querySelectorAll('[style]');
      for (var j = 0; j < enfants.length; j++) corriger(enfants[j]);
      textes(r);
      if (!suivis.has(r)) {
        suivis.add(r);
        obsRacine.observe(r, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'aria-checked', 'class'] });
      }
    }
  }

  function planifier() {
    if (prevu) return;
    prevu = true;
    setTimeout(function () { prevu = false; passe(); }, 30);  // pas de requestAnimationFrame : il dort quand l'onglet est caché
  }

  function demarrer() {
    passe();
    new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true });
    // une case cochée ne change pas le DOM : on repasse après le clic, le temps que l'app mette son état à jour
    ['click', 'change'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(planifier, 160); }, true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
